module.exports = __webpack_public_path__ + "static/img/declare_three.6644752.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/declare_three.jpg
// module id = bxMZ
// module chunks = 1